class AstAccordions extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll(".ast-accordions__item");

    this.items.forEach((item) => {
      const toggle = item.querySelector(".ast-accordions__toggle");
      toggle.addEventListener("click", () => this.toggleItem(item, toggle));
    });
  }

  toggleItem(item, toggle) {
    const isActive = item.classList.contains("ast-accordions__item--active");

    if (isActive) {
      item.classList.remove("ast-accordions__item--active");
      toggle.setAttribute("aria-expanded", "false");
    } else {
      item.classList.add("ast-accordions__item--active");
      toggle.setAttribute("aria-expanded", "true");
    }
  }
}

if (!customElements.get("ast-accordions")) {
  customElements.define("ast-accordions", AstAccordions);
}
